export default function toBaseLocale(locale: string): string {
  return (locale || '').split('-')[0]
}
